import * as React from 'react';
import AppFooter from '../modules/views/AppFooter';
import NavBar from '../modules/views/NavBar';
import withRoot from '../modules/withRoot';
import ContactForm from './ContactForm';
import PageHead from '../modules/views/PageHead';
import PageMeta from '../modules/components/PageMeta';

function Index() {
  return (
    <React.Fragment>
      <PageMeta
        title="お問い合わせ"
        description="飯田建築へのお問い合わせ。新築・リフォームのご相談、お見積りは無料です。お電話（04-2932-1316）またはフォームからお気軽にご連絡ください。"
        path="/contact"
      />
      <NavBar />
      <PageHead eyebrow="Contact" title="お問い合わせ" lead="見積・ご相談は無料です。お気軽にお問い合わせください。" />
      <ContactForm />
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(Index);
